import { render, staticRenderFns } from "./AppointmentRecap.vue?vue&type=template&id=b9c73318&scoped=true&"
import script from "./AppointmentRecap.ts?vue&type=script&lang=ts&"
export * from "./AppointmentRecap.ts?vue&type=script&lang=ts&"
import style0 from "./AppointmentRecap.scss?vue&type=style&index=0&id=b9c73318&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c73318",
  null
  
)

export default component.exports